<template>
  <div
    v-if="competitionIsOpen"
    :class="$b()"
    :style="{ height: iframeHeight }"
  >
    <iframe
      :src="competitionSrc"
      frameborder="0"
      scrolling="no"
      :class="$b('iframe')"
    />
  </div>
</template>

<script>
export default {
  name: 'EmbeddedCompetition',
  props: {
    competition: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      iframeHeight: '0px',
    }
  },
  computed: {
    competitionIsOpen() {
      return this.$dayjs(this.competition?.closingDatetime) > this.$dayjs()
    },
    competitionSrc() {
      return `https://win.sungod.co/${this.competition.slug}`
    },
  },
  mounted() {
    window.addEventListener('message', this.iframeMessageHandler)
  },
  beforeUnmount() {
    window.removeEventListener('message', this.iframeMessageHandler)
  },
  methods: {
    iframeMessageHandler(e) {
      if (!e?.origin.match('https://win.sungod.co')) return
      const message = e.data

      if (message.height) {
        this.iframeHeight = message.height + 'px'
      }

      if (message.scrollToPos) {
        const navigationElem = document.querySelector('nav')
        const navigationHeight = navigationElem.clientHeight
        window.scrollTo(0, parseInt(message.scrollToPos + navigationHeight))
      }
    },
  },
}
</script>

<style lang="postcss">
.EmbeddedCompetition {
  @apply w-full h-full min-h-[80vh] overflow-y-hidden
    rounded-[10px];
}

.EmbeddedCompetition__iframe {
  @apply w-full h-full overflow-y-hidden;
}
</style>
